import DashboardRoute from "./dashboard/Dashboard.Route";
import MasterRoute from './master/MasterRoute';
import SettingsRoute from './settings/SettingsRoute';
import UsersRoute from './users/UsersRoute';
import VendorRoute from "./vendor/Vendor.Route";
import SubscriptionRoute from "./subscription/Subscription.Route";
import ShopRoute from "./shop/ShopRoute"

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...MasterRoute(),
        ...SettingsRoute(),
        // ...UsersRoute(),
        ...VendorRoute(),
        ...SubscriptionRoute(),
        ...ShopRoute(),
    ]
}

export default PrivateRoute